import React from "react";

const Footer = () => {
  return (
    <footer className="bg-dark border-t border-gray-200 text- text-center p-4 mt-auto">
      Developed by <span className="font-semibold">SelectCode</span>
    </footer>
  );
};

export default Footer;
